import $ from 'jquery';

const Menu = () => {
    const $menu = $('#siteNav');
    const $button = $('#buttonMenu');
    const $closeButton = $('.siteNav__closeButton');
    const $overlay = $('<div id="navOverlay" class="navOverlay"/>').appendTo('body');

    const init = () => {
        if (!$menu.length) {
            return;
        }

        // Event Listeners
        $button.on('click', toggle);
        $closeButton.on('click', close);

        $menu.on('click', '.menu-item-button', function () {
            if (window.outerWidth < 1600) {
                const $button = $(this);
                const $item = $button.parents('.menu-item');
                $item.toggleClass('open');
                $button.toggleClass('open');
                $item.find('.sub-menu').slideToggle();
            }
        });

        $(window).on('scroll load', () => {
            const scrollTop = $(window).scrollTop();
            $button.toggleClass('sticky', scrollTop > 0);
        });

        $(document).on('click', handleClickOutside);
        $(document).on('keydown', handleEscapeKey);
    }

    const isOpen = () => $menu.hasClass('visible');

    const open = () => {
        $button.addClass('close');
        $menu.addClass('visible');
        $overlay.addClass('visible');
    };

    const close = () => {
        $button.removeClass('close');
        $menu.removeClass('visible');
        $overlay.removeClass('visible');
    };

    const toggle = (e) => {
        e.preventDefault();
        isOpen() ? close() : open();
    };

    const handleClickOutside = (e) => {
        if (isOpen() && !$menu[0].contains(e.target) && !$button[0].contains(e.target)) {
            close();
        }
    };

    const handleEscapeKey = (e) => {
        if (e.key === 'Escape' && isOpen()) {
            close();
            $button.focus();
        }
    };

    return Object.freeze({ init, close, open });
};

export default Menu;